import React from 'react'
import style from './amountCard.module.scss'
import { useSelector } from 'react-redux'
import VegaColors from '../../../resources/constants/colors.module.scss'
import { KnownFees } from '../../../resources/constants/KnownFees'
import { VegaCurrency } from '../../../components/vega/currency/Currency'
import { AmountCardActor } from '../amountCardActor/AmountCardActor'
import { AmountCardPlus } from '../amountCardPlus/AmountCardPlus'
import { useTranslation } from 'react-i18next'
import cx from 'classnames'
import { toPascalCase } from '../../../utils/string'

export const PureAmountCard = ({
	classname,
	amount,
	creditor,
	beneficiary,
	carrier,
	fees
}) => {
	const { t, i18n } = useTranslation()
	return (
		<div className={cx(style.amountCard, classname)}>
			<div className={style.card}>
				<div className={style.header}>
					<div className={style.amount}>
						<div className={style.number}>
							<div className={style.fake}>
								{new Intl.NumberFormat(i18n.language, {
									minimumIntegerDigits: 12,
									minimumFractionDigits: 2
								}).format(amount?.amount || 0)}
							</div>
							{amount?.amount && (
								<div className={style.real}>
									{new Intl.NumberFormat(i18n.language, {
										minimumFractionDigits: 2
									}).format(amount?.amount)}
								</div>
							)}
						</div>
						<VegaCurrency
							trigram={amount?.currency}
							color={VegaColors.CONTENTBLACK}
							size={'big'}
						/>
					</div>
				</div>
				<div className={style.body}>
					<AmountCardActor
						actorName={creditor?.name}
						bank={creditor?.bank}
						accountNumber={creditor?.accountNumber}
					/>
					<AmountCardActor
						actorName={beneficiary?.name}
						bank={beneficiary?.bank}
						accountNumber={beneficiary?.accountNumber}
						isBeneficiary
					/>
				</div>
				{(carrier?.id || fees) && (
					<div className={style.footer}>
						{carrier?.id &&
							(carrier?.id === 'SWIFT' && carrier?.reference ? (
								<AmountCardPlus
									label={t('plusCarrierLabelSwift')}
									labelTip={t('plusCarrierLabelTipSwift')}
									value={carrier?.reference}
									valueCopy={true}
								/>
							) : (
								<AmountCardPlus
									label={t('plusCarrierLabelDefault')}
									value={t(`plusCarrierValue${toPascalCase(carrier?.id)}`)}
								/>
							))}
						{fees &&
							(KnownFees.includes(fees?.bearer) ? (
								<AmountCardPlus
									label={t(`plusFeesLabel${toPascalCase(fees?.bearer)}`)}
									value={t(`plusFeesValue${toPascalCase(fees?.bearer)}`)}
								/>
							) : (
								<AmountCardPlus label={t('plusFeesLabelDefault')} value={fees?.bearer} />
							))}
					</div>
				)}
			</div>
		</div>
	)
}

/**
 * This component is smart and uses payment, creditor and beneficiary datas
 */
export const AmountCard = () => {
	const { creditor, beneficiary, payment } = useSelector((state) => state.TrackerReducer)
	return (
		<PureAmountCard
			creditor={creditor}
			beneficiary={beneficiary}
			amount={payment?.amount}
			carrier={payment?.carrier}
			fees={payment?.fees}
			classname={cx('animate__animated', 'animate__fadeInRight')}
		/>
	)
}
